import React from 'react';
import {
  LeanClaimSummaryDTO,
} from 'dtos';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import Tag from 'core/components/Tag';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  formatDate,
} from 'utils/date';

const claimIdColumn: ColumnDef<LeanClaimSummaryDTO> = {
  id: 'claimId',
  header: 'Claim ID',
  size: 200,
  minSize: 180,
  accessorKey: 'externalId',
  columnTitle: 'Claim ID',
  cell: ({ row }) => <span className="text-xs font-medium">{row.original.externalId}</span>,
};

const statusColumn: ColumnDef<LeanClaimSummaryDTO> = {
  id: 'status',
  header: 'Current Status',
  accessorKey: 'status',
  size: 160,
  columnTitle: 'Current Status',
  cell: ({ row }) => <Tag tagName={row.original.status ?? ''} className="!text-xs !font-medium" />,
};

const patientNameColumn: ColumnDef<LeanClaimSummaryDTO> = {
  id: 'patientName',
  header: 'Patient Name',
  accessorKey: 'patientName',
  size: 180,
  columnTitle: 'Patient Name',
  meta: { autoSized: true },
  cell: ({ row }) => <span className="text-xs font-medium">{row.original.patientName}</span>,
};

const visitDateColumn: ColumnDef<LeanClaimSummaryDTO> = {
  id: 'visitDate',
  header: 'Visit Date',
  accessorKey: 'visitDate',
  size: 120,
  columnTitle: 'DOS',
  cell: ({ row }) => <span className="text-xs font-medium">{formatDate(row.original.dateOfService ?? '')}</span>,
};

function getRemoveColumn(
  onRemove: (claimId: number) => void,
): ColumnDef<LeanClaimSummaryDTO> {
  return {
    id: 'remove',
    size: 48,
    columnTitle: '',
    cell: ({ row }) => (
      <IconButton
        size="small"
        aria-label={`Remove claim ${row.original.externalId ?? ''}`}
        title="Remove"
        onClick={() => onRemove(row.original.claimId ?? 0)}
        className="!text-gray-400 hover:!text-gray-800"
      >
        <CloseIcon className="!w-4 !h-4" />
      </IconButton>
    ),
  };
}

const columns: ColumnDef<LeanClaimSummaryDTO>[] = [
  patientNameColumn,
  claimIdColumn,
  visitDateColumn,
  statusColumn,
];

export default function getClaimPreviewColumns(onRemove?: (claimId: number) => void) {
  return onRemove ? [...columns, getRemoveColumn(onRemove)] : columns;
}
